<template>
  <v-container
    class="assets-view-container"
    fluid
  >
    <h1>Assets</h1>
    <assets-table
      :assets="assets"
      :assets-pagination="assetsPagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { AssetsTable } from '@/components/baader';

export default {
  name: 'Assets',
  components: {
    'assets-table': AssetsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.assetsStore.loading,
      assets: state => state.assetsStore.assets,
      assetsPagination: state => state.assetsStore.assetsPagination,
    }),
  },
  async mounted() {
    this.getAssets(toQueryString({ sort: 'created_at', dir: 'desc', page: 1, limit: 25 }));
  },
  methods: {
    ...mapActions(['getAssets']),
  },
};
</script>


<style lang="scss" scoped>
.assets-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/baader/Assets.vue